import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const InformationHeading = styled.h2`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  ${down('md')} {
    margin-bottom: 16px;
    font-size: 20px;
  }
`

export const InformationCardContainer = styled.div<{ isMobile: boolean; isTablet?: boolean }>`
  display: flex;
  flex-direction: row;
  ${(props) =>
    (props.isMobile || props.isTablet) &&
    `
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
  `}
`

export const InformationCardWrapper = styled.div``

export const InformationCard = styled.div<{ isMobile: boolean; isTablet?: boolean }>`
  display: ${(props) => (props.isMobile || props.isTablet) && 'flex'};
  width: ${(props) => (props.isMobile || props.isTablet ? 'auto' : '267px')};
  border: 1px solid #d7dddb;
  border-radius: 8px;
  box-shadow: 0px 5px 22px 4px transparent;
  background-color: #ffffff;
  padding: 16px;
  height: auto;
  gap: 12px;
  margin-right: ${(props) => !props.isMobile && !props.isTablet && '16px'};
  transition-duration: 0.2s;

  &:hover {
    box-shadow: 0px 5px 22px 4px #0000001f;
  }

  @media screen and (max-width: 768px) {
    flex-grow: 1;
    &:nth-child(3) {
      margin-right: 0;
    }
  }
`

export const InformationCardLink = styled.a<{ isTablet?: boolean }>`
  ${down('md')} {
    display: flex;
  }
  ${(props) => props.isTablet && 'display: flex;'}
`

export const Image = styled.div<{ isTablet?: boolean }>`
  height: auto;
  width: auto;
  margin: 0px auto;
  border-radius: 50%;
  margin-bottom: 12px;
  @media screen and (max-width: 962px) {
    margin-right: 24px;
    margin-bottom: 0;
  }
  ${(props) =>
    props.isTablet &&
    `
    margin-right: 24px;
    margin-bottom: 0;
  `}
`
export const informationCardHeading = styled.div`
  color: #131717;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 21px;
  padding-bottom: 4px;
  padding-top: 2px;
  width: 21ch;
`
export const informationCardSubheading = styled.div`
  color: #131717;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
`

export const InformationCardSmContainer = styled.div`
  padding: 0 10px;
  margin-left: 6px;
`

export const InformationCardSm = styled.div`
  display: flex;
  align-items: center;
  width: 255px;
  border: 1px solid #d7dddb;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 16px;
  height: 66px;
  gap: 12px;
  box-shadow: 0px 5px 22px 4px transparent;
  transition-duration: 0.2s;

  &:hover {
    box-shadow: 0px 5px 22px 4px #0000001f;
  }
`
export const ImageSm = styled.div`
  display: flex;
  height: auto;
  width: auto;
  border-radius: 50%;

  > svg {
    color: #2dc44d;
  }
`

export const DividerContainer = styled.div`
  /* padding-left: 10px; */
  padding-top: 7.5px;
  @media screen and (max-width: 962px) {
    display: none;
  }
`

export const Divider = styled.div`
  height: 148px;
  width: 1px;
  background-color: #eff3f2;
`
export const MobileCards = styled.div`
  @media screen and (max-width: 962px) {
    display: none;
  }
`
